export function isDeclarableQualificationNeeded(identifierDeclaration: string | null | undefined) {
    return !!identifierDeclaration && identifierDeclaration.startsWith('84');
}
